import { createAction } from 'redux-actions';
import axios from 'axios';
import AuthService from '../../services/AuthService';
import jwtDecode from 'jwt-decode';
import { handleGetUniversity } from './university';
export const LOGIN_USER_PENDING = createAction('LOGIN_USER_PENDING');
export const LOGIN_USER_SUCCESS = createAction('LOGIN_USER_SUCCESS');
export const LOGIN_USER_ERROR = createAction('LOGIN_USER_ERROR');
export const LOGOUT_USER = createAction('LOGOUT_USER');


export const hangleLoginUser = (username, password, history) => {
    return async (dispatch, getState) => {
        const cancelToken = axios.CancelToken.source();
        dispatch(LOGIN_USER_PENDING(cancelToken));
        try{
            const result = await AuthService.login(username, password);   
            const data = jwtDecode(result.data.access);         
            const user = {
              token: result.data.access,
              refresh: result.data.refresh,
              university: data.universities && data.universities.length > 0 ? data.universities[0] : null,
              profile: data.profile_type,
              extraData:{
                ...data.user_data,
                ...result.data.extra_data
              }
            };
            if( user.profile !== 'manager' && user.profile !== 'teacher'){
              dispatch(LOGIN_USER_ERROR("Wrong permissions"));  
            } else if(!user.university){
              dispatch(LOGIN_USER_ERROR("Wrong permissions"));  
            }else{
              localStorage.setItem('user',  JSON.stringify(user));
              dispatch(LOGIN_USER_SUCCESS(user));
              dispatch(handleGetUniversity());
              history.push('/dashboard');
            }            
        }catch (error) {
          const statusCode = error.response ? error.response.status : 0;
          if (statusCode === 401) {
            dispatch(LOGIN_USER_ERROR("Wrong email or password."));
          }else{
            dispatch(LOGIN_USER_ERROR("Try again later."));            
            console.log(error);
          }          
        }
    };
};

export const hangleLogout = () => {
  return (dispatch, getState) => {
      AuthService.logout();
      dispatch(LOGOUT_USER());      
  };
};